var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"response-message",attrs:{"bordered":false}},[_c('Icon',{staticClass:"message-icon",attrs:{"type":"md-close-circle","size":"120","color":"#ed4014"}}),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.message)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }